import { defineStore } from 'pinia'

const loadStoredUser = () => {
  try {
    const raw = window.localStorage.getItem('pinia_user')
    if (!raw) return { userinfo: null, loginExpiry: null }
    const parsed = JSON.parse(raw)
    return {
      userinfo: parsed.userinfo || null,
      loginExpiry: parsed.loginExpiry || null,
    }
  } catch (error) {
    return { userinfo: null, loginExpiry: null }
  }
}

const persistUser = (payload) => {
  try {
    window.localStorage.setItem('pinia_user', JSON.stringify(payload))
  } catch (error) {}
}

const clearStoredUser = () => {
  try {
    window.localStorage.removeItem('pinia_user')
  } catch (error) {}
}

/**
 * 사용자 정보/로그인 만료 관리 (Pinia)
 * - Vuex userinfoModule 대체용 준비
 */
export const useUserStore = defineStore('user', {
  state: () => ({
    /** @type {import('@/types/user').UserInfo|null} */
    ...loadStoredUser(),
  }),
  actions: {
    /**
     * @param {import('@/types/user').UserInfo|null} payload
     */
    setUserinfo(payload) {
      this.userinfo = payload
      persistUser({ userinfo: this.userinfo, loginExpiry: this.loginExpiry })
    },
    /**
     * @param {number|null} ts
     */
    setLoginExpiry(ts) {
      if (ts === this.loginExpiry) return
      this.loginExpiry = ts
      persistUser({ userinfo: this.userinfo, loginExpiry: this.loginExpiry })
    },
    removeUserinfo() {
      this.userinfo = null
      this.loginExpiry = null
      clearStoredUser()
    },
  },
})

export default useUserStore
